/**
 * SA-1204 (spec §5): a first-quote duration. Over the target it wears the quiet
 * warning class and a Tip naming the target; the focusable span carries the tip
 * (the SA-1034 rule: never a native title beside it). A register table cell passes
 * `tip="title"` instead: a native title on a non-focusable span, no extra Tab stop.
 */
import { Tip } from '@/components/ui/Tip'
import { durationWords, targetTip } from './firstQuoteText'

export function FirstQuoteDuration({ minutes, over, targetMinutes, tip = 'tip' }: {
  minutes: number
  over: boolean
  targetMinutes: number
  /** 'title' is for a register table cell (SA-1034: a native title, no extra Tab stop). */
  tip?: 'tip' | 'title'
}) {
  const words = <b className="font-semibold">{durationWords(minutes)}</b>
  if (!over) return words
  if (tip === 'title') {
    return <span title={targetTip(targetMinutes)} className="text-warning-strong">{words}</span>
  }
  return (
    <Tip text={targetTip(targetMinutes)}>
      <span tabIndex={0} className="text-warning-strong">{words}</span>
    </Tip>
  )
}
